import { render, staticRenderFns } from "./TabelaprecoList.vue?vue&type=template&id=4b587ccb&scoped=true"
import script from "./TabelaprecoList.vue?vue&type=script&lang=js"
export * from "./TabelaprecoList.vue?vue&type=script&lang=js"
import style0 from "./TabelaprecoList.vue?vue&type=style&index=0&id=4b587ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b587ccb",
  null
  
)

export default component.exports